/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { LFB } from '@nexigendigital/nxui'
import { Address } from 'models/account'
import { useAppSelector } from 'store/hooks'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    initialValues: Address,
    setPrefillValues: (values: Address) => void,
    setTemplate: (template: 'selector' | 'contact') => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function ContactSelector({ initialValues, setPrefillValues, setTemplate }: Props) {
    const { appSession: { user, account } } = useAppSelector((state) => state.app)
    const { account_holder, company_name } = account!

    /****************************************************
     *  COMPONENT RENDER
     ****************************************************/
    return (
        <StyledContactSelector>
            <LFB
                disabled={false}
                label={'Use Account Details'}
                description={company_name ? `${account_holder} - ${company_name}` : account_holder}
                onClick={() => {
                    setPrefillValues({
                        firstname: user!.firstname,
                        lastname: user!.lastname,
                        phone: user!.phone,
                        email: user!.email,
                        company_name: company_name,
                        address1: user!.address.address1 || '',
                        address2: user?.address.address2 || '',
                        suburb: user!.address.city,
                        postcode: user!.address.postcode,
                        state: 'VIC',
                        country: 'AU'
                    })
                    setTemplate('contact')
                }}
            />
            <LFB
                disabled={false}
                label={'Use New Account Details'}
                onClick={() => {
                    setPrefillValues(initialValues)
                    setTemplate('contact')
                }}
            />
        </StyledContactSelector>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const StyledContactSelector = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0 20px 15px;

    > button {
        width: 100%;
    }
`
